import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/protocol.png'
import _imports_2 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7c59a097")

_pushScopeId("data-v-7c59a097")
const _hoisted_1 = { class: "Ecard" }
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "versionGeneration versionGeneration2",
  style: {}
}, null, -1)
const _hoisted_17 = { id: "perf_report" }
const _hoisted_18 = { class: "spacName" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_20 = { class: "mainContent" }
const _hoisted_21 = { class: "spacName" }
const _hoisted_22 = { class: "gameTable" }
const _hoisted_23 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_24 = {
  colspan: 4,
  class: "game_name"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "【", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "】", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 版本: ")
const _hoisted_28 = { colspan: 2 }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 安装文件: ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 开始测试: ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 测试结果: ")
const _hoisted_32 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "自动化协议测试")
], -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 测试机型: ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 结束测试: ")
const _hoisted_35 = { class: "corePerformance spacName" }
const _hoisted_36 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试结论")
], -1)
const _hoisted_37 = { class: "corePerformance-list" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "失败Case列表", -1)
const _hoisted_39 = { class: "spacName" }
const _hoisted_40 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("详细测试结果")
], -1)
const _hoisted_41 = { style: {"font-weight":"bold"} }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "gallery__big_box" }
const _hoisted_44 = {
  ref: "mask",
  class: "gallery__big_wrap"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini",
                    class: "spacForm queryReport",
                    disabled: _ctx.loading
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "报告名称" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.report_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.report_id = $event)),
                            placeholder: "请选择",
                            onChange: _ctx.report_change
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smoke_lists, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: 
                      item.report_name +
                      '-[' +
                      item.create_date.replace('T', ' ') +
                      ']'
                    ,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_popconfirm, {
                            onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                            title: "确认删除该报告？",
                            placement: "top"
                          }, {
                            reference: _withId(() => [
                              _createVNode(_component_el_button, {
                                size: "mini",
                                type: "info",
                                disabled: _ctx.get_is_super
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tooltip, {
                                    effect: "dark",
                                    content: "暂无管理员权限",
                                    placement: "top",
                                    disabled: !_ctx.get_is_super
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.sendOut,
                            class: "down_img"
                          }, {
                            default: _withId(() => [
                              _hoisted_4,
                              _hoisted_5
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_7,
                                    _hoisted_8,
                                    _hoisted_9,
                                    _hoisted_10,
                                    _hoisted_11,
                                    _hoisted_12,
                                    _hoisted_13
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_16,
                  _createVNode("div", _hoisted_17, [
                    _withDirectives(_createVNode("div", _hoisted_18, [
                      _hoisted_19
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _withDirectives(_createVNode("table", _hoisted_22, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_23, [
                              _createVNode("img", {
                                src: _ctx.smokeReport?.base.project_icon
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("td", _hoisted_24, [
                              _hoisted_25,
                              _createTextVNode(_toDisplayString(_ctx.smokeReport?.base.project_name), 1),
                              _hoisted_26
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_27,
                              _createVNode("span", null, _toDisplayString(_ctx.smokeReport?.base.version), 1)
                            ]),
                            _createVNode("td", _hoisted_28, [
                              _hoisted_29,
                              _createVNode("span", null, _toDisplayString(_ctx.smokeReport?.base.filename), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_30,
                              _createVNode("span", null, _toDisplayString(_ctx.smokeReport?.base.start_time), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_31,
                              _createVNode("span", null, [
                                _createVNode("b", {
                                  style: {
                              color:
                                _ctx.smokeReport?.base.status === '失败'
                                  ? 'red'
                                  : '#00b050',
                            }
                                }, _toDisplayString(_ctx.smokeReport?.base.status), 5)
                              ])
                            ]),
                            _hoisted_32,
                            _createVNode("td", null, [
                              _hoisted_33,
                              _createVNode("span", null, _toDisplayString(_ctx.smokeReport?.base.model_name), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_34,
                              _createVNode("span", null, _toDisplayString(_ctx.smokeReport?.base.end_time), 1)
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode("div", _hoisted_37, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smoke_List, (item, index) => {
                            return (_openBlock(), _createBlock("div", { key: index }, [
                              _createVNode("p", {
                                style: 
                          'color:' +
                          (index == _ctx.smoke_List.length - 1
                            ? parseFloat(item.num) / 100 < 0.8
                              ? 'red'
                              : '#00b050'
                            : '')
                        
                              }, _toDisplayString(item.num), 5),
                              _createVNode("p", null, _toDisplayString(item.name), 1)
                            ]))
                          }), 128))
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      (_ctx.smokeReport?.failed_case_list?.length)
                        ? (_openBlock(), _createBlock(_component_el_table, {
                            key: 0,
                            size: "mini",
                            data: _ctx.smokeReport?.failed_case_list,
                            "header-cell-style": {
                    background: '#CCCCCC',
                    color: 'black',
                  }
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, { label: "失败Case列表" }, {
                                header: _withId(() => [
                                  _hoisted_38
                                ]),
                                default: _withId(() => [
                                  _createVNode(_component_el_table_column, { label: "Case名" }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.case_desc), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    width: "80",
                                    label: "所属系统"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.case_model), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    width: "",
                                    label: "上发协议"
                                  }, {
                                    default: _withId((scope) => [
                                      (!scope.row.is_case)
                                        ? (_openBlock(), _createBlock("span", {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.toggleData(scope)),
                                            style: {"cursor":"pointer","text-decoration":"underline","color":"blue"}
                                          }, _toDisplayString(scope.row.case_protocol_name), 9, ["onClick"]))
                                        : (_openBlock(), _createBlock("div", {
                                            key: 1,
                                            onClick: ($event: any) => (_ctx.toggleData(scope)),
                                            style: {"cursor":"pointer"}
                                          }, [
                                            _createVNode("div", null, _toDisplayString(scope.row.case_protocol_name), 1),
                                            _createVNode("div", null, _toDisplayString(scope.row.send_data), 1)
                                          ], 8, ["onClick"]))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    width: "",
                                    label: "校验协议"
                                  }, {
                                    default: _withId((scope) => [
                                      (!scope.row.is_check)
                                        ? (_openBlock(), _createBlock("span", {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.toggleDataCheck(scope)),
                                            style: {"cursor":"pointer","text-decoration":"underline","color":"blue"}
                                          }, _toDisplayString(scope.row.check_protocol_name), 9, ["onClick"]))
                                        : (_openBlock(), _createBlock("div", {
                                            key: 1,
                                            onClick: ($event: any) => (_ctx.toggleDataCheck(scope)),
                                            style: {"cursor":"pointer"}
                                          }, [
                                            _createVNode("div", null, _toDisplayString(scope.row.check_protocol_name), 1),
                                            _createVNode("div", null, _toDisplayString(scope.row.check_data), 1)
                                          ], 8, ["onClick"]))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    width: "400",
                                    label: "失败原因"
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", {
                                        style: 'color:' + (scope.row.run_desc ? 'red' : '')
                                      }, _toDisplayString(scope.row.run_desc), 5)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode("div", _hoisted_39, [
                        _hoisted_40,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.all_case_list, (item, i, index) => {
                          return (_openBlock(), _createBlock("div", { key: index }, [
                            _createVNode("span", _hoisted_41, _toDisplayString(i), 1),
                            _createVNode(_component_el_table, {
                              border: "",
                              "span-method": (params) => _ctx.spanMethod(params, item),
                              size: "mini",
                              data: item.case_list,
                              "header-cell-style": {
                        background: '#5D99D5',
                        color: '#fff',
                      }
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, { label: "Case名" }, {
                                  default: _withId((scope) => [
                                    (!scope.row.case_protocol_id)
                                      ? (_openBlock(), _createBlock("span", {
                                          key: 0,
                                          style: 
                              'color:' +
                              (scope.row.check_result == 1 ? '#00b050' : 'red')
                            
                                        }, _toDisplayString(scope.row.case_desc), 5))
                                      : (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(scope.row.case_desc), 1))
                                  ]),
                                  _: 1
                                }),
                                (_ctx.localProject != 62)
                                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                                      key: 0,
                                      width: "80",
                                      label: "上发ID"
                                    }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.case_protocol_id), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_table_column, {
                                  label: _ctx.localProject == 62 ? '自动触发方式' : '上发协议'
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.case_protocol_name), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_table_column, { label: "指定值" }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.send_params), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, { label: "校验协议" }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.check_protocol_name), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, { label: "检查值" }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.check_params), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, { label: "执行结果/截图" }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: 
                              'color:' +
                              (scope.row.check_result == 1 ? '#00b050' : 'red')
                            
                                    }, _toDisplayString(scope.row.run_desc), 5),
                                    _createVNode(_component_el_image, {
                                      src: scope.row.image,
                                      "preview-src-list": [scope.row.image],
                                      fit: "contain",
                                      style: {"width":"120px","height":"67px"}
                                    }, null, 8, ["src", "preview-src-list"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, { label: "执行时间" }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.run_time), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["span-method", "data"])
                          ]))
                        }), 128))
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ])
                  ])
                ]),
                _withDirectives(_createVNode("div", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.maskBtn($event))),
                  class: "gallery__big"
                }, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("div", _hoisted_44, [
                      _createVNode("img", { src: _ctx.maskImg }, null, 8, ["src"])
                    ], 512)
                  ])
                ], 512), [
                  [_vShow, _ctx.showMask]
                ]),
                _hoisted_45
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})